module.exports = __webpack_public_path__ + "img/tittle_bg.656601c1.png";